import React from 'react';
import { FaPlus } from 'react-icons/fa';
// import { connect } from 'react-redux';
import './style.scoped.scss';
import { TbLayoutSidebarLeftCollapse } from 'react-icons/tb';
import QueryItems from './QueryItems';
import Collapse from './Collapse';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

// const mapStateToProps = (state) => ({
//   docsList: state.client.documents,
//   // queries: state.queries.queries,
// });

// const connector = connect(mapStateToProps, {});

const QueryList = (props) => {
  const {
    createNewQuery,
    hideRecentQueries,
    handleSearchInputChange,
    queries,
    searchQuery,
    user,
  } = props;

  // console.log('QueryList', queries);

  const filteredQueries =
    queries &&
    queries.filter((query) => {
      const titleMatches = new RegExp(searchQuery, 'i').test(query.title);
      const contentMatches =
        query &&
        query.queryContent.length > 0 &&
        query.queryContent?.some(
          (content) =>
            (content.message &&
              content.message
                .toLowerCase()
                .includes(searchQuery.toLowerCase())) ||
            (content.response.response &&
              content.response.response
                .toLowerCase()
                .includes(searchQuery.toLowerCase()))
        );
      return titleMatches || contentMatches;
    });

  return (
    <React.Fragment>
      <div className='topHeaderList'>
        <h3 className='text-center m-0 p-0'>Recent Queries</h3>
        <OverlayTrigger
          placement='right'
          overlay={<Tooltip id='button-tooltip'>Hide Recent Queries</Tooltip>}
        >
          <div id='hide-sidebar' onClick={hideRecentQueries}>
            <TbLayoutSidebarLeftCollapse />
          </div>
        </OverlayTrigger>
      </div>

      {user.remainingQueries <= 0 && user.remainingAdditionalQueries <= 0 ? (
        <OverlayTrigger
          placement='right'
          overlay={
            <Tooltip id='button-tooltip'>
              You have consumed all AI Queries Credits
            </Tooltip>
          }
        >
          <button
            className='newQueryBtn'
            disabled={true}
            style={{
              cursor: 'not-allowed',
            }}
          >
            <span className='mr-3'>
              <FaPlus />
            </span>
            New Query
          </button>
        </OverlayTrigger>
      ) : (
        <button
          className='newQueryBtn'
          onClick={createNewQuery}
          disabled={
            user.remainingQueries <= 0 && user.remainingAdditionalQueries <= 0
          }
        >
          <span className='mr-3'>
            <FaPlus />
          </span>
          New Query
        </button>
      )}
      <input
        type='text'
        placeholder='Search Query...'
        value={searchQuery}
        onChange={(e) => handleSearchInputChange(e.target.value)}
        className='queriesList__input'
      />
      {searchQuery !== '' && filteredQueries && filteredQueries.length > 0 ? (
        <div className='queriesList'>
          <QueryItems {...props} queries={filteredQueries} />
        </div>
      ) : (
        <div className='queriesList'>
          {queries &&
            queries.length > 0 &&
            queries.filter((query) => query.queryDay === 'Today').length >
              0 && (
              <Collapse
                {...props}
                itemName='Today'
                queries={queries.filter((query) => query.queryDay === 'Today')}
              />
            )}
          {queries &&
            queries.length > 0 &&
            queries.filter((query) => query.queryDay === 'Previous7').length >
              0 && (
              <Collapse
                {...props}
                itemName='Previous 7 Days'
                queries={queries.filter(
                  (query) => query.queryDay === 'Previous7'
                )}
              />
            )}
          {queries &&
            queries.length > 0 &&
            queries.filter((query) => query.queryDay === 'Previous').length >
              0 && (
              <Collapse
                {...props}
                itemName='Previous 30 Days'
                queries={queries.filter(
                  (query) => query.queryDay === 'Previous'
                )}
              />
            )}
        </div>
      )}
    </React.Fragment>
  );
};

export default QueryList;
